import { motion } from 'framer-motion';

import NamedLink from 'components/NamedLink/NamedLink';
import { useGeolocation } from 'hooks/useGeolocation';
import { cn } from 'util/cn';
import { categoryOptions, productTypeOptions } from 'util/productOptions/productTypeDefinitions';

const BG_ICONS = [
  {
    label: 'Denina Martin',
    handle: 'Deninamartin',
  },
  {
    label: 'Denitsa Stoyanova',
    handle: 'denitsa.stoyanovaa',
  },
  {
    label: 'Mademoiselle Aia',
    handle: 'mademoiselleaia',
  },
  {
    label: 'Hristiana Parova',
    handle: 'hrisiparova',
  },
  {
    label: 'Maya Paunovska',
    handle: 'mayapaunovska',
  },
];
const ICONS = [
  {
    label: 'Leonie Hanne',
    handle: 'leoniehanne',
  },
  {
    label: 'Danielle Copperman',
    handle: 'dcopperman',
  },
  {
    label: 'Maria Guardiola',
    handle: 'mariaguardiola',
  },
  {
    label: 'Mollie Corish',
    handle: 'Mollieeec',
  },
  {
    label: 'Yvona Zypet',
    handle: 'YVZUX',
  },
  {
    label: 'Lilyisa Bella Clark',
    handle: 'lilyisabellaclark',
  },
  {
    label: 'Amelia Taylor',
    handle: 'withameliataylor',
  },
];

function TopbarDesktopShopMenu({
  className,
  onClickItem,
}: {
  className?: string;
  onClickItem: () => void;
}) {
  const geolocation = useGeolocation();
  const isInBulgaria = geolocation?.userGeolocation === 'BG';

  const sections = categoryOptions.map(section => {
    return (
      <div key={section.value} className="flex flex-col gap-2">
        <h2 className="font-syne uppercase font-bold">
          <NamedLink
            name="SearchPage"
            to={{
              search: `category=${section.value}`,
            }}
            onClick={onClickItem}
          >
            {section.label}
          </NamedLink>
        </h2>
        <ul className="flex flex-col items-stretch">
          {productTypeOptions
            .filter(option => option?.showPredicate?.({ category: section.value }))
            .map(option => {
              return (
                <li key={option.value} className="w-full">
                  <NamedLink
                    name="SearchPage"
                    to={{
                      search: `category=${section.value}&productType=${option.value}`,
                    }}
                    onClick={onClickItem}
                    className="py-1 w-full"
                  >
                    {option.label}
                  </NamedLink>
                </li>
              );
            })}
        </ul>
      </div>
    );
  });

  sections.push(
    <div key="icons" className="flex-col gap-2 hidden lg:flex">
      <h2 className="font-syne uppercase font-bold">Icons</h2>
      <ul className="flex flex-col items-stretch">
        {(isInBulgaria ? BG_ICONS : ICONS).map(icon => {
          return (
            <li key={icon.handle} className="w-full">
              <NamedLink
                name="ProfilePageWithHandle"
                params={{ handle: icon.handle }}
                className="py-1 w-full"
              >
                {icon.label}
              </NamedLink>
            </li>
          );
        })}
      </ul>
    </div>
  );

  const menuVariants = {
    hidden: {
      opacity: 0,
      y: 10,
      transition: {
        duration: 0.2,
        ease: 'easeInOut',
      },
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.2,
        ease: 'easeOut',
      },
    },
  };

  return (
    <motion.div
      className="bg-[#f5f7fa]"
      initial="hidden"
      animate="visible"
      exit="hidden"
      variants={menuVariants}
    >
      <div
        className={cn(
          'max-w-[var(--n-content-max-width)] mx-auto w-full px-3 lg:px-10 py-5 flex [&>*]:flex-1 gap-4 backdrop-blur',
          className
        )}
      >
        {sections}
      </div>
    </motion.div>
  );
}

export default TopbarDesktopShopMenu;
